const preprodConfig = {
  envsToReplace: [ 'dev', 'dev2', 'dev3', 'qa', 'qa2', 'preprod', 'preprod2', 'www2' ],
  value: 'pre-prod',
  endpoints: [ 'ugcImageBucket' ],
  endpointsToSkipDomainPrefixing: {
    customizer: [
      'sharingButtonUrl',
    ],
  },
};

export { preprodConfig };
